// extracted by mini-css-extract-plugin
export default {"fab":"fields_fab__X-Ws8","transaction":"fields_transaction__1pmT8","sliderContainer":"fields_sliderContainer__y34Ig"};